import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AlertComponent } from '@shared/components/alert/alert.component';
import { GlobalSpinnerComponent } from '@shared/components/global-spinner/global-spinner.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, AlertComponent, GlobalSpinnerComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent {
  title = 'luna-nueva-properties-backoffice-fe';
}
